import {getAppOrigin} from '@salesforce/pwa-kit-react-sdk/utils/url'
import logger from '@salesforce/retail-react-app/app/utils/logger-instance'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'

export const addGCToCart = async (token, giftCertificateData, basket) => {
    const basketId = basket.basketId
    const amount = giftCertificateData?.amount
    const recipientEmail = giftCertificateData?.recipientEmail
    const shipmentId = giftCertificateData?.shipmentId
    const recipientName = giftCertificateData?.recipientName
    const senderName = giftCertificateData?.senderName
    const config = getConfig()
    const body = JSON.stringify({
        amount: amount,
        recipientEmail: recipientEmail,
        shipmentId: shipmentId,
        recipientName: recipientName,
        senderName: senderName
    })
    if (token) {
        try {
            const apiUrl = `${getAppOrigin()}/mobify/proxy/api/checkout/shopper-baskets/v2/organizations/${
                config?.app?.commerceAPI?.parameters?.organizationId
            }/baskets/${basketId}/gift-certificate-items?siteId=${config?.app?.defaultSite}`

            const response = await fetch(apiUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`
                },
                body: body
            })
                .then((res) => res.json())
                .then((json) => {
                    return json
                })

            return response
        } catch (error) {
            logger.error('Error while adding gift certificate to basket:', error)
            return false
        }
    }
}
